import type { FormInstance } from '@arco-design/web-react';

import type { ComputeModalResourceKind, ComputePaths } from '../types';
import { isComputeResourceConfigured } from './summary';

export function createComputeResourceRequiredRule(
  kind: ComputeModalResourceKind,
  form: FormInstance,
  paths: ComputePaths,
  message: string,
  billModelId?: string,
  paymentTiming?: string,
  skuType?: string,
  resourceEditMode?: string,
) {
  return {
    validator(_value: unknown, callback: (error?: string) => void) {
      const values = form.getFieldsValue() as Record<string, unknown>;
      if (isComputeResourceConfigured(kind, values, paths, billModelId, paymentTiming, skuType, resourceEditMode)) {
        callback();
        return;
      }
      callback(message);
    },
  };
}

/** 各资源类型对应的表单校验字段（仅数量/规格） */
export function resolveComputeResourceValidateFields(
  kind: ComputeModalResourceKind,
  paths: ComputePaths,
  cpuSimpleMode?: boolean,
): string[] {
  if (kind === 'cpu') {
    if (cpuSimpleMode && paths.cpuRequest) return [paths.cpuRequest];
    return [paths.cpuCards];
  }
  if (kind === 'memory') return [paths.memory];
  return [`${paths.gpu}.number`];
}

export function hasComputeResourceFieldError(form: FormInstance, fields: string[]): boolean {
  return fields.some((field) => {
    const err = form.getFieldError(field) as { message?: string } | string | ({ message?: string } | string)[] | null | undefined;
    if (!err) return false;
    if (typeof err === 'string') return Boolean(err.trim());
    if (Array.isArray(err)) {
      return err.some((item) => Boolean(typeof item === 'string' ? item.trim() : item?.message));
    }
    return Boolean(err.message);
  });
}
